<template>
<div class='activity_info-sign-in-overlay'>
  <div class='activity_info-sign-in-overlay_inner'>
    <button
      ref='close-button'
      class='activity_info-sign-in-overlay_close'
      title='Close'
      @click.prevent='toggleSignInOverlay'
    >
      <CloseIcon />
    </button>

    <p class='activity_info-sign-in-overlay_copy h-four'>
      {{ $t('please_sign_in') }}
    </p>

    <button
      class='activity_info-sign-in-overlay_button action-one-branded'
      @click.prevent='toggleSignInOverlay'
    >
      {{ $t('close') }}
    </button>
  </div>
</div>
</template>

<script>
import CloseIcon from '../icons/close.svg'

export default {
  props: ['toggleSignInOverlay'],

  components: {
    CloseIcon
  },

  mounted() {
    this.$refs['close-button'].focus()
  }
}
</script>

<style lang='sass' scoped>
@import './sign-in-overlay'
</style>
